import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ChequeGiroModel,
  ChequeGiroMutationInput,
  ChequeGiroDeleteInput,
  ChequeGiroUpdateInput,
} from './model';

export function useCreateChequeGiro(
  options?: UseMutationOptions<
    ApiResult<ChequeGiroModel>,
    ApiError,
    ChequeGiroMutationInput
  >,
): UseMutationResult<
  ApiResult<ChequeGiroModel>,
  ApiError,
  ChequeGiroMutationInput
> {
  return useMutation<
    ApiResult<ChequeGiroModel>,
    ApiError,
    ChequeGiroMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'cheque-giros',
      method: 'POST',
      classType: ChequeGiroModel,
      body,
    });
  }, options);
}

export function useUpdateChequeGiro(
  options?: UseMutationOptions<
    ApiResult<ChequeGiroModel>,
    ApiError,
    ChequeGiroUpdateInput
  >,
): UseMutationResult<
  ApiResult<ChequeGiroModel>,
  ApiError,
  ChequeGiroUpdateInput
> {
  return useMutation<
    ApiResult<ChequeGiroModel>,
    ApiError,
    ChequeGiroUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `cheque-giros/${body.chequeGiroId}`,
      method: 'PUT',
      classType: ChequeGiroModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteChequeGiro(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    ChequeGiroDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, ChequeGiroDeleteInput> {
  return useMutation<{ message: string }, ApiError, ChequeGiroDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `cheque-giros/${body.chequeGiroId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
